<template>
	<v-flex d-flex xs12 style="page-break-inside: avoid">
		<v-card color='grey darken-2'>
			<v-card-text class="financial-table-header-font-size financial-table-header-dark-color">
				<strong>
					A. Koszty administracyjne
				</strong>
			</v-card-text>
		</v-card>
	</v-flex>
</template>
<script>
	export default {
		name: 'final-report-administrative-header'
	};
</script>